import type { SessionType as PrismaSessionType } from '@generated/prisma/enums';

// Re-export Prisma `SessionType` type
export type SessionType = PrismaSessionType;

export const SessionType: { [K in PrismaSessionType]: K } = {
  GAME: 'GAME',
  PRACTICE: 'PRACTICE',
  UNKNOWN: 'UNKNOWN',
  WORKOUT: 'WORKOUT',
};
